import { UserRole } from '../types/UserRole';

export const userRoleLabels = {
  [UserRole.ROLE_ADMIN]: '관리자',
  [UserRole.ROLE_GUEST]: '게스트',
};
